import React from 'react';

interface BlankPageProps {
  lang: string;
}

export const BlankPage: React.FC<BlankPageProps> = ({ lang }) => {
  const englishLabel = 'Coming soon';
  const frenchLabel = 'Bientôt disponible';

  return <div className="ml-4">{lang === 'en' ? <h2>{englishLabel}</h2> : <h2>{frenchLabel}</h2>}</div>;
};

export default BlankPage;